var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInvestmentsChart(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Basics",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Basics/Icons",
    transform: "translate(-5026.000000, -636.000000)",
    fill: "#262626"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Investments/Chart",
    transform: "translate(5026.000000, 636.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.41,16.9999201 C5.777,20.9219017 8.285,24.3188857 11.925,25.8238787 C15.565,27.3298716 19.74,26.6968746 22.769,24.1798864 L26.58,27.9998684 C23.667,30.5918562 19.899,32.0168496 16,31.9998496 C7.539,32.0168496 0.529,25.4428804 0,16.9999201 L5.41,16.9999201 Z M26.599,16.9699203 L32,16.9699203 C31.8,20.3539044 30.517,23.5798892 28.349,26.175877 L28,26.5798751 L24.18,22.769893 C25.433,21.2289002 26.248,19.3829089 26.542,17.4239181 L26.599,16.9699203 L32,16.9699203 L26.599,16.9699203 Z M12,15.9999248 L12,19.999906 L9,19.999906 L9,18.9999107 C9,17.3429185 10.343,15.9999248 12,15.9999248 L12,15.9999248 Z M17,12.9999389 L17,19.999906 L14,19.999906 L14,15.9999248 C14,14.3429326 15.343,12.9999389 17,12.9999389 L17,12.9999389 Z M22,9.99995301 L22,19.999906 L19,19.999906 L19,12.9999389 C19,11.3429467 20.343,9.99995301 22,9.99995301 L22,9.99995301 Z M15,0 L15,5.33997491 C10.015,5.84297254 6.049,9.7039544 5.383,14.6369312 L5.34,14.9999295 L0,14.9999295 C0.491,6.92796745 6.928,0.490997693 15,0 L15,0 Z M17,0 C24.91,0.478997749 31.227,6.71996842 31.843,14.5779315 L31.87,14.9999295 L26.53,14.9999295 C26.081,10.0369528 22.264,6.06197151 17.36,5.3839747 L17,5.33997491 L17,0 Z",
    id: 32
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvestmentsChart);
export default __webpack_public_path__ + "static/media/investments-chart.0b061532.svg";
export { ForwardRef as ReactComponent };